import { z } from 'zod';

export const DefensiveSchema = z.object({
	commercialName: z.string().min(1, 'Nome comercial é obrigatório'),
	manufacturerId: z.string().min(1, 'Fabricante é obrigatório'),
	nature: z.string().min(1, 'Natureza do produto é obrigatória'),
	class: z.array(z.string().min(1)).min(1, 'Classe agronômica é obrigatória'),
	culture: z.array(z.string()).min(1, 'Cultura recomendada é obrigatória'),
	applicationForm: z
		.array(z.string())
		.min(1, 'Selecione ao menos um modo de aplicação'),
	dose: z
		.string()
		.min(1, 'Dose base é obrigatória')
		.refine(v => !Number.isNaN(Number(v)) && Number(v) > 0, 'Dose deve ser um número positivo'),
	doseMeasurementUnit: z.string().optional(),
	syrupVolume: z.string().optional(),
	commonPests: z.string().optional(),
	activeIngredients: z
		.array(
			z.object({
				name: z.string(),
				concentration: z.string(),
			}),
		)
		.optional(),
});

export type DefensiveSchemaType = z.infer<typeof DefensiveSchema>;
